import React, { useContext } from 'react';
import { Row, Col, Card, Tooltip, Spin, Avatar, Tag, Popover } from 'antd';
import { Context } from '../context';
import { Appearer } from './Appearer';
import { LinkedinFilled, GlobalOutlined, InstagramOutlined, EllipsisOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import categories_colors from '../static/categories_colors.json';
import Badge from './Badge';

export const AlumniCard = ({ entry }) => {

  const navigate = useNavigate();
  const { x } = useContext(Context);
  // Split credits into lines and limit to 3 lines for preview
  // const creditsLines = entry.alumniCredits;
  // const previewCredits = creditsLines.slice(0, 2);
  // const previewCredits = "";

  return (<div className="_rel">

    {/* <div
      className="badges"
      onMouseEnter={(e) => {
        e.stopPropagation();
        e.preventDefault();
      }}
    >
      {entry.badges.map(one =>
        <Tooltip
          title={one.filename}
        >
          <div
            className='badge'
            style={{ backgroundImage: `url(${one.thumbnails.large.url})` }} />
        </Tooltip>)}
    </div> */}

    <Card
      hoverable
      className='_pointer'
      styles={{
        body: {
          padding: "0 0 32px 0",
          // margin: '0 auto',
        }
      }}
    // cover={<img alt={entry.person} src={entry.demoReelCover} />} // Placeholder image
    >


      <div className="_fv _fgap1 _backzoom0">


        {entry.accolades.length > 0 && <div
          className="badges"
        >
          {entry.accolades.map(accoladeId =>
            <Badge
              key={`badge_${accoladeId}`}
              one={x.getAccoladeById(accoladeId)}
              alumnuData={entry}
              page={false}
            />
          )}
        </div>
        }



        <div className="_clickable"
          onClick={() => {
            navigate(`/${entry.handle}`);
          }}
        />

        <div style={{ overflow: 'hidden' }}>

          <div
            className='_backzoom'
            style={{
              '--angleSize': '8px',
              clipPath: 'polygon(0 var(--angleSize), var(--angleSize) 0, 100% 0, 100% calc(100% - var(--angleSize)), calc(100% - var(--angleSize)) 100%, 0 100%)',
              overflow: 'hidden',
              backgroundImage: `url(${entry.demoReelCover}/m/1200x800)`,
              backgroundSize: 'cover',
              backgroundPosition: '0 0',
              backgroundColor: '#2e2e2e',
              aspectRatio: '16/9',
              // maxHeight: '70vh',
            }}
          />
        </div>
        <div className="_f _fm  _fgap02">
          <div className="_f _f _fgap08">
            <Avatar
              style={{
                backgroundColor: '#ffd20b6b',
                flexShrink: 0,
                color: '#000000',
                // backgroundImage: entry.headshot[0] ? `url(${entry.headshot[0].thumbnails.small.url})` : '',
                backgroundImage: entry.headshot ? `url(${entry.headshot})` : '',
                filter: 'grayscale(100%)',
                backgroundSize: 'cover',
                backgroundPosition: '50% 50%',
                borderRadius: '0%',
                backgroundColor: '#ffd40b',
                color: '#000',
                border: '0',
                '--angleSize': '4px',
                clipPath: 'polygon(0 var(--angleSize), var(--angleSize) 0, 100% 0, 100% calc(100% - var(--angleSize)), calc(100% - var(--angleSize)) 100%, 0 100%)',
                padding: '0.4em 2em !important',
                cursor: 'pointer'
              }}
              size={28}
            >
              <b>{!entry.headshot && entry.name.charAt(0)}</b>
            </Avatar>
            <div className='_fv _fgap02'>
              <h3 className='alumni-name'>{entry.name}</h3>
              <div className='_f _fgap02 _fwrap'
                style={{
                  // color: categories_colors[one],
                  fontSize: '0.8em',
                  fontWeight: '600',
                }}
              >
                {entry.categories.map(one => one.trim()).join(', ')}
                {/* {entry.categories.map(one => <div
                  className='_o08'
                  key={`preview_${one}_${entry._id}`}
                  style={{
                    // color: categories_colors[one],
                    fontSize: '0.8em',
                    fontWeight: '600',
                    padding: '0',
                    lineHeight: '1em',
                    maxWidth: '14em', margin: '0 0em',
                    border: '0'
                  }}>{one}</div>)} */}
                {/* {entry.categories.map(one => <Tag
                  borderless
                  color={categories_colors[one]}
                  key={`preview_${one}_${entry._id}`}
                  style={{
                    fontSize: '0.8em',
                    padding: '0.3em 0.6em 0.4em 0.6em',
                    lineHeight: '1em',
                    maxWidth: '14em', margin: '0 0em',
                    border: '0'
                  }}>{one}</Tag>)} */}
              </div>
            </div>
          </div>
          {/* <div>{entry.studentType}</div> */}
          <div>
            {/* Display preview of credits */}
            <div>
              {/* {previewCredits.map(one => <div key={`preview_${one}_${entry._id}`} className='ellipsis' style={{ maxWidth: '14em' }}>{one}</div>)} */}
            </div>
            {/* {creditsLines.length > 3 && (
              <Tooltip title={entry.alumniCredits} placement="top">
                <EllipsisOutlined style={{ marginLeft: '8px', cursor: 'pointer' }} />
              </Tooltip>
            )} */}
          </div>
          {/* <div className='_fgrow _f _fgap2 _o06' style={{ marginLeft: '1em' }}> */}
          {/* <a
              style={{ position: 'relative', zIndex: 2 }}
              // href={entry.linkedIn}
              onClick={(e) => {
                e.stopPropagation();
                window.open(entry.linkedIn, '_blank');
              }}
              target="_blank" rel="noopener noreferrer">
              <LinkedinFilled style={{ fontSize: '16px' }} />
            </a> */}
          {/* <a
              style={{ position: 'relative', zIndex: 2 }}
              // href={entry.alumniWebsite}
              onClick={(e) => {
                e.stopPropagation();
                window.open(entry.alumniWebsite, '_blank');
              }}
              target="_blank" rel="noopener noreferrer">
              <GlobalOutlined style={{ fontSize: '16px' }} />
            </a> */}
          {/* <a
              style={{ position: 'relative', zIndex: 2 }}
              // href={entry.instagram}
              onClick={(e) => {
                e.stopPropagation();
                window.open(entry.instagram, '_blank');
              }}
              target="_blank" rel="noopener noreferrer">
              <InstagramOutlined style={{ fontSize: '16px' }} />
            </a> */}
          {/* </div> */}
        </div>

      </div>
    </Card>
  </div>
  );
};